import { ChevronDownIcon } from '../Icons';

import Styles from './index.module.scss';
import { useHandlers } from './useHandlers';

import type { Props } from './types';

export const TimePicker = ({ value, onChange }: Props) => {
	const { header, headerValue, handleChange } = useHandlers({ value, onChange });

	const timeType = value?.timeType ?? 'daily';
	const monthlyClassName = timeType === 'monthly' ? Styles.monthly : '';
	const customClassName = timeType === 'custom' ? Styles.custom : '';

	return (
		<div
			className={`
			${Styles.container} 
			${monthlyClassName} 
			${customClassName}`}
		>
			<button type="button" onClick={() => handleChange(-1)}>
				<ChevronDownIcon />
			</button>
			<div>
				<h4>{header}</h4>
				<span>{headerValue}</span>
			</div>
			<button type="button" onClick={() => handleChange(1)}>
				<ChevronDownIcon />
			</button>
		</div>
	);
};
